import React from "react";
import Name from "../../../../search/schema/components/Name";
import {
  DnsData,
  HttpData,
  NetworkItems,
  TcpUdpData,
  UrlData
} from "../../../@types/rldynamicanalysis";
import { enums } from "../../../../../shim/jsbridge";
import { NetworkRepEntry } from "../../../../network/@types/Url";
import { ClassificationIcon, NoData } from "../../../../../components";
import NetworkReferenceReputation, {
  NetworkReferenceReputationGridTitle
} from "../../report_summary/cards/network_references/NetworkReferenceReputation";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

const ClassificationIconField = {
  name: "status",
  displayTitle: (
    <span style={{ opacity: "0.3" }} className="threat threat-placeholder" />
  ),
  sortable: false,
  component: (networkRepEntry: NetworkRepEntry) => (
    <ClassificationIcon classification={networkRepEntry.classification} />
  ),
  style: {
    width: "3%"
  },
  className: "threat-table-cell"
};

const EnrichedRlCloudSandboxNetworkFields = [
  {
    name: "categories",
    displayTitle: "Categories",
    sortable: false,
    component: (item: NetworkRepEntry) =>
      (item?.categories || []).join(", ") || <NoData />,
    style: { width: "20%" }
  },
  {
    name: "reputation",
    displayTitle: <NetworkReferenceReputationGridTitle />,
    sortable: false,
    component: (networkRepEntry: NetworkRepEntry) => (
      <NetworkReferenceReputation networkRepEntry={networkRepEntry} />
    ),
    style: {
      width: "12%"
    }
  }
];

export const RlCloudSandboxNetworkItems: NetworkItems = {
  http: {
    title: "HTTP",
    schema: {
      fields: [
        ClassificationIconField,
        {
          name: "url",
          displayTitle: "URL",
          sortable: true,
          component: (d: HttpData & NetworkRepEntry) => (
            <Name
              data={{
                file_name: d.url ?? "",
                int_submission_analyzer: URLANALYZER,
                classification: d.classification
              }}
            />
          ),
          style: { width: "45%" }
        },
        {
          name: "method",
          displayTitle: "Method",
          sortable: true,
          component: (d: HttpData & NetworkRepEntry) => d.method,
          style: { width: "20%" }
        },
        ...EnrichedRlCloudSandboxNetworkFields
      ]
    }
  },
  tcp: {
    title: "TCP",
    schema: {
      fields: [
        ClassificationIconField,
        {
          name: "destination_ip",
          displayTitle: "Destination IP",
          sortable: true,
          component: (d: TcpUdpData & NetworkRepEntry) => (
            <Name
              data={{
                file_name: d.destination_ip ?? "",
                int_submission_analyzer: URLANALYZER,
                classification: d.classification
              }}
            />
          ),
          style: { width: "45%" }
        },
        {
          name: "destination_port",
          displayTitle: "Destination Port",
          sortable: true,
          component: (d: TcpUdpData & NetworkRepEntry) => d.destination_port,
          style: { width: "20%" }
        },
        ...EnrichedRlCloudSandboxNetworkFields
      ]
    }
  },
  udp: {
    title: "UDP",
    schema: {
      fields: [
        ClassificationIconField,
        {
          name: "destination_ip",
          displayTitle: "Destination IP",
          sortable: true,
          component: (d: TcpUdpData & NetworkRepEntry) => (
            <Name
              data={{
                file_name: d.destination_ip ?? "",
                int_submission_analyzer: URLANALYZER,
                classification: d.classification
              }}
            />
          ),
          style: { width: "45%" }
        },
        {
          name: "destination_port",
          displayTitle: "Destination Port",
          sortable: true,
          component: (d: TcpUdpData & NetworkRepEntry) => d.destination_port,
          style: { width: "20%" }
        },
        ...EnrichedRlCloudSandboxNetworkFields
      ]
    }
  },
  dns: {
    title: "DNS",
    schema: {
      fields: [
        ClassificationIconField,
        {
          name: "type",
          displayTitle: "Type",
          sortable: true,
          component: (d: DnsData & NetworkRepEntry) => d.type,
          style: { width: "15%" }
        },
        {
          name: "value",
          displayTitle: "Value",
          sortable: true,
          component: (d: DnsData & NetworkRepEntry) => (
            <Name
              data={{
                file_name: d.value ?? "",
                int_submission_analyzer: URLANALYZER,
                classification: d.classification
              }}
            />
          ),
          style: { width: "30%" }
        },
        {
          name: "ip",
          displayTitle: "IP",
          sortable: true,
          component: (d: DnsData & NetworkRepEntry) =>
            !d.address || d.address === "none" ? (
              <NoData />
            ) : (
              <Name
                data={{
                  file_name: d.address ?? "",
                  int_submission_analyzer: URLANALYZER
                }}
              />
            ),
          style: { width: "20%" }
        },
        ...EnrichedRlCloudSandboxNetworkFields
      ]
    }
  },
  url: {
    title: "URL",
    schema: {
      fields: [
        ClassificationIconField,
        {
          name: "url",
          displayTitle: "URL",
          sortable: true,
          component: (d: UrlData & NetworkRepEntry) => (
            <Name
              data={{
                file_name: d.url ?? "",
                int_submission_analyzer: URLANALYZER,
                classification: d.classification
              }}
            />
          ),
          style: { width: "45%" }
        },
        {
          name: "source",
          displayTitle: "Source",
          sortable: true,
          component: (d: UrlData & NetworkRepEntry) => d.source,
          style: { width: "20%" }
        },
        ...EnrichedRlCloudSandboxNetworkFields
      ]
    }
  }
};
